import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'dgx-top-data-chart-list',
  templateUrl: './top-data-chart-list.component.html',
})
export class TopDataChartListComponent implements OnInit {
  @Input() public chartName;
  @Input() public headerList;
  @Input() public listData;
  @Input() public labelKey1;
  @Input() public labelKey2;
  @Input() public progressData;
  @Input() public isLoading;
  public i18n = this.translate.instant(['Core_NoResults']);

  constructor(private translate: TranslateService) {}

  public ngOnInit(): void {}
}
